// extracted by mini-css-extract-plugin
export default {"wrapper":"EventModal_wrapper__UVPVC","text":"EventModal_text__coqoN","header":"EventModal_header__W0hj-"};